import { getFullNameFromUnknown, getStringFromRecord } from './_nameHelpers';

import { TicketDetail, TicketSummary } from '@/services/TicketsService';

export function getTicketOpenerName(
  ticket: TicketSummary | TicketDetail,
): string | undefined {
  const ticketRecord = ticket as unknown as Record<string, unknown>;
  const createdByName = getFullNameFromUnknown(ticketRecord.createdBy);

  if (createdByName) {
    return createdByName;
  }

  const openerName =
    ticket.createdByName?.trim() ||
    ticket.createdByUserName?.trim() ||
    ticket.openerName?.trim() ||
    ticket.requesterName?.trim() ||
    ticket.createdByFirstName?.trim() ||
    getStringFromRecord(ticketRecord, 'customerUserName') ||
    getStringFromRecord(ticketRecord, 'openedByName') ||
    getStringFromRecord(ticketRecord, 'ownerName');

  if (openerName) {
    return openerName;
  }

  const composedOpenerName =
    `${ticket.createdByFirstName ?? ''} ${ticket.createdByLastName ?? ''}`.trim();

  if (composedOpenerName) {
    return composedOpenerName;
  }

  return getFullNameFromUnknown(ticket.createdByUser);
}
